export default "__VITE_ASSET__ntoOEB9C__"